package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CodeW500Rounded: ImageVector
    get() {
        if (_codeW500Rounded != null) {
            return _codeW500Rounded!!
        }
        _codeW500Rounded = Builder(name = "CodeW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(197.3f, 480.76f)
                lineToRelative(151.18f, 151.17f)
                quadToRelative(12.91f, 12.92f, 12.79f, 31.95f)
                quadToRelative(-0.12f, 19.03f, -13.03f, 31.95f)
                quadToRelative(-12.91f, 12.91f, -31.83f, 12.79f)
                quadToRelative(-18.91f, -0.12f, -31.82f, -12.79f)
                lineToRelative(-184.0f, -183.76f)
                quadToRelative(-6.72f, -6.72f, -9.82f, -14.92f)
                quadToRelative(-3.1f, -8.19f, -3.1f, -17.15f)
                quadToRelative(0.0f, -8.96f, 3.1f, -17.15f)
                quadToRelative(3.1f, -8.2f, 9.82f, -14.92f)
                lineToRelative(184.0f, -184.0f)
                quadToRelative(13.67f, -13.67f, 32.32f, -13.67f)
                quadToRelative(18.66f, 0.0f, 32.33f, 13.67f)
                quadToRelative(13.67f, 13.68f, 13.67f, 32.45f)
                quadToRelative(0.0f, 18.77f, -13.67f, 32.45f)
                lineTo(197.3f, 480.76f)
                close()
                moveTo(762.7f, 479.24f)
                lineTo(611.52f, 328.07f)
                quadToRelative(-12.91f, -12.92f, -12.79f, -31.95f)
                quadToRelative(0.12f, -19.03f, 13.03f, -31.95f)
                quadToRelative(12.91f, -12.91f, 31.83f, -12.79f)
                quadToRelative(18.91f, 0.12f, 31.82f, 12.79f)
                lineToRelative(184.0f, 183.76f)
                quadToRelative(6.72f, 6.72f, 9.82f, 14.92f)
                quadToRelative(3.1f, 8.19f, 3.1f, 17.15f)
                quadToRelative(0.0f, 8.96f, -3.1f, 17.15f)
                quadToRelative(-3.1f, 8.2f, -9.82f, 14.92f)
                lineToRelative(-184.0f, 184.0f)
                quadToRelative(-13.67f, 13.67f, -31.94f, 13.29f)
                quadToRelative(-18.27f, -0.38f, -31.95f, -14.06f)
                quadToRelative(-13.67f, -13.67f, -13.67f, -32.44f)
                quadToRelative(0.0f, -18.77f, 13.67f, -32.45f)
                lineTo(762.7f, 479.24f)
                close()
            }
        }
        .build()
        return _codeW500Rounded!!
    }

private var _codeW500Rounded: ImageVector? = null
